import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NInput = _resolveComponent("NInput")!

  return (_openBlock(), _createBlock(_component_NInput, {
    placeholder: _ctx.$t('common.search', 'f'),
    class: "camera-lookup-search",
    "suffix-icon": "search",
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event))
  }, null, 8, ["placeholder", "modelValue"]))
}